import { BoxxGenericState, getGenericInitialState } from '@boxx/core';
import {
  IStoreVariationsStateError,
  IStoreVariationsStateSuccess,
  StoreVariationsStateType,
  VariationModel,
} from '@boxx/store-core';
import { ActionReducer, createReducer, on } from '@ngrx/store';
import * as fromVariationsActions from './store-variations.actions';

export interface IStoreVariationsState
  extends BoxxGenericState<
    VariationModel[],
    IStoreVariationsStateSuccess,
    IStoreVariationsStateError
  > {
  selectedVariation: VariationModel;
}

export const variationsInitialState: IStoreVariationsState = {
  ...getGenericInitialState(),
  data: [],
  selectedVariation: null,
};

export const storeVariationsReducer: ActionReducer<IStoreVariationsState> =
  createReducer(
    variationsInitialState,
    on(
      fromVariationsActions.loadVariationsBeginAction,
      fromVariationsActions.loadVariationByIdBeginAction,
      // fromVariationsActions.creteVariationBeginAction,
      // fromVariationsActions.delteVariationBeginAction,
      (state, action): IStoreVariationsState => ({
        ...state,
        isLoading: true,
        error: null,
        success: null,
      })
    ),
    on(
      fromVariationsActions.loadVariationsSuccessAction,
      // fromVariationsActions.creteVariationSuccessAction,
      fromVariationsActions.delteVariationSuccessAction,
      (state, action): IStoreVariationsState => ({
        ...state,
        isLoading: false,
        fetched: true,
        data: action.payload,
        error: null,
        success: { after: getStoreVariationsActionType(action.type) },
      })
    ),
    on(
      fromVariationsActions.loadVariationByIdSuccessAction,
      (state, action) => ({
        ...state,
        isLoading: false,
        fetched: true,
        selectedVariation: action.payload,
        error: null,
        success: { after: getStoreVariationsActionType(action.type) },
      })
    ),
    on(
      fromVariationsActions.loadVariationsFailAction,
      fromVariationsActions.loadVariationByIdFailAction,
      // fromVariationsActions.creteVariataionFailAction,
      fromVariationsActions.delteVariationFailAction,
      (state, action): IStoreVariationsState => ({
        ...state,
        isLoading: false,
        error: {
          after: getStoreVariationsActionType(action.type),
          error: action.errors,
        },
        success: null,
      })
    ),
    on(
      fromVariationsActions.clearVariationsSuccessErrorDataAction,
      (state) => ({
        ...state,
        error: null,
        success: null,
      })
    )
  );

const getStoreVariationsActionType = (
  type: fromVariationsActions.StoreVariationsActionTypes
) => {
  let action: StoreVariationsStateType;

  switch (type) {
    case fromVariationsActions.StoreVariationsActionTypes.loadVariationsSuccess:
    case fromVariationsActions.StoreVariationsActionTypes.loadVariationsFail:
      action = 'LOAD_VARIATIONS';
      break;
    case fromVariationsActions.StoreVariationsActionTypes
      .createVariationSuccess:
    case fromVariationsActions.StoreVariationsActionTypes.createVariationFail:
      action = 'CREATE_VARIATION';
      break;
    case fromVariationsActions.StoreVariationsActionTypes
      .deleteVariationSuccess:
    case fromVariationsActions.StoreVariationsActionTypes.deleteVariationFail:
      action = 'DELETE_VARIATION';
      break;
    default:
      action = 'UNKNOWN';
  }

  return action;
};
